/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} St_Seg_AgencyInputs */

const en_st_seg_agency = /** @type {(inputs: St_Seg_AgencyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`An agency`)
};

const id_st_seg_agency = /** @type {(inputs: St_Seg_AgencyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agensi`)
};

/**
* | output |
* | --- |
* | "An agency" |
*
* @param {St_Seg_AgencyInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const st_seg_agency = /** @type {((inputs?: St_Seg_AgencyInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<St_Seg_AgencyInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_st_seg_agency(inputs)
	return en_st_seg_agency(inputs)
});